import { Navigate, Route } from "react-router";

import { Goto } from "@/shared/navigation";

import { CreateTrigger } from "./CreateTrigger";
import { EditTrigger } from "./EditTrigger";
import { Trigger } from "./Trigger";
import { TriggersPage } from "./TriggersPage";

/**
 * Routes for the top-level Triggers section. Spread directly into the app's
 * route tree.
 *
 * One list shows every trigger; whether it fires on events or a schedule is a
 * filter on that list, carried in the URL. The old Scheduled tab's URL
 * redirects into that filter so saved links keep working.
 *
 * The detail route is registered last and matches `/triggers/:triggerName/*`;
 * React Router ranks the static `scheduled` and `create` segments above the
 * dynamic one, so neither is mistaken for a trigger name. The same ranking
 * keeps `/triggers/:triggerName/edit` off the detail page's splat, so editing
 * is its own page rather than a tab.
 */
export const TriggersRoutes = () => [
  <Route key={"triggers"} path="/triggers" element={<TriggersPage />} />,
  <Route
    key={"triggersScheduled"}
    path="/triggers/scheduled"
    element={<Navigate to={Goto.createTriggersRoute("schedule")} replace />}
  />,
  <Route
    key={"triggerCreate"}
    path="/triggers/create"
    element={<CreateTrigger />}
  />,
  <Route
    key={"triggerEdit"}
    path="/triggers/:triggerName/edit"
    element={<EditTrigger />}
  />,
  <Route
    key={"triggerDetail"}
    path="/triggers/:triggerName/*"
    element={<Trigger />}
  />,
];
